export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceContentsBasicInfo: {
        serviceContentsId: 1,
        serviceContentsUuid: "servicecontents001",
        contentsName: "アコミュニティサポート",
        serviceType: "hoambox",
        deviceType: "JS01H",
        screenOrientationKbn: 1
      },
      serviceContentsScreenSettings: [
        {
          screenConfigMstId: 1,
          screenConfigMstUuid: "screenconfigmst001",
          contentsScreenId: 1,
          contentsScreenUuid: "contentsscreen001",
          screenName: "トップ画面",
          screenConfigName: "コミュニティサポート向けトップ画面",
          isHomeScreen: 1,
          isReleased: 1
        }
      ]
    }
  }
}